function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 17.4V6.6m0 3.156h9",
  stroke: "#fff",
  strokeWidth: "1.5",
  strokeMiterlimit: "10",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 18.3a.907.907 0 01-.9-.9V6.6c0-.492.408-.9.9-.9.492 0 .9.408.9.9v10.8c0 .492-.408.9-.9.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 15.144h-9c-.492 0 .1-.408.1-.9 0-.492-.592-.9-.1-.9h9c.492 0 .9.408.9.9 0 .492-.408.9-.9.9z"
})));